// Document type mapping between frontend and backend
export const DOCUMENT_TYPE_MAP = {
  // Frontend -> Backend
  nin: 'bvn',
  cac: 'cac',
  tin: 'tin',
  passport: 'passport',
  utility: 'proofOfAddress',
  director: 'directorInfo'
} as const;

// Reverse mapping for backend -> frontend
export const REVERSE_DOCUMENT_TYPE_MAP = {
  bvn: 'nin',
  cac: 'cac',
  tin: 'tin',
  passport: 'passport',
  proofOfAddress: 'utility',
  directorInfo: 'director'
} as const;

// Get backend type from frontend type
export const getBackendDocumentType = (frontendType: string): string => {
  return DOCUMENT_TYPE_MAP[frontendType as keyof typeof DOCUMENT_TYPE_MAP] || frontendType;
};

// Get frontend type from backend type
export const getFrontendDocumentType = (backendType: string): string => {
  return REVERSE_DOCUMENT_TYPE_MAP[backendType as keyof typeof REVERSE_DOCUMENT_TYPE_MAP] || backendType;
};

// Get display label for document type
export const getDocumentTypeLabel = (type: string): string => {
  const labels: { [key: string]: string } = {
    bvn: 'Bank Verification Number (BVN)',
    cac: 'Corporate Affairs Commission (CAC)',
    tin: 'Tax Identification Number (TIN)',
    passport: 'International Passport',
    proofOfAddress: 'Proof of Address',
    directorInfo: 'Director Information'
  };
  return labels[type] || type;
};

// Get frontend display label
export const getFrontendDocumentTypeLabel = (frontendType: string): string => {
  const backendType = getBackendDocumentType(frontendType);
  return getDocumentTypeLabel(backendType);
};

export type FrontendDocumentType = keyof typeof DOCUMENT_TYPE_MAP;
export type BackendDocumentType = typeof DOCUMENT_TYPE_MAP[keyof typeof DOCUMENT_TYPE_MAP];
